<template>
  <a :href="iosStoreLink">
    <img 
      style="height: 50px"
    src="@/assets/appleStore.svg" :alt="$t('alts.appStore')" />
  </a>
</template>
<script>
import { IOS_STORE_STORY_CITY_URL } from  "@/const"
export default {
  computed: {
    iosStoreLink() {
      return IOS_STORE_STORY_CITY_URL 
    }
  }
}
</script>